const formatDateTime = () => {
    const now = new Date();
    // For the date part: e.g., "Wednesday"
    const dateOptions = { weekday: 'long' };
    // For the time part: e.g., "12:19 PM"
    const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };

    const datePart = now.toLocaleDateString('en-US', dateOptions);
    const timePart = now.toLocaleTimeString('en-US', timeOptions);

    // Combining the date and time parts
    return `${datePart} ${timePart}`;
};

// This function checks if a URL is an image or not
function isImageURL(url) {
    if (url === undefined || url === '') return false;
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'ico'];
    const extension = url.split('.').pop();
    return imageExtensions.includes(extension);
}

const generateDarkColor = () => {
    let color = "#";
    for (let i = 0; i < 3; i++) {
        let randomNum = Math.floor(Math.random() * 254);
        let hex = randomNum.toString(16);
        color += hex.length === 1 ? "0" + hex : hex;
    }
    return color;
}

const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

// Add more humanity to tts
const enhanceTextForTTS = (value, convertToWords = false) => {
    // Handle null, undefined, or empty values
    if (value === null || value === undefined || value === '') {
        return '';
    }

    // Internal helper to convert numbers to words (supports numbers up to 999,999)
    const convertNumberToWords = (num) => {
        if (num === 0) return 'zero';

        const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        // Helper to convert numbers below 1000
        const convertHundred = (n) => {
            let words = '';

            if (n >= 100) {
                words += ones[Math.floor(n / 100)] + ' hundred';
                n %= 100;
                if (n) words += ' and ';
            }

            if (n >= 20) {
                words += tens[Math.floor(n / 10)];
                if (n % 10) words += '-' + ones[n % 10];
            } else if (n >= 10) {
                words += teens[n - 10];
            } else if (n > 0) {
                words += ones[n];
            }

            return words;
        };

        // For numbers below 1000, use the helper directly
        if (num < 1000) {
            return convertHundred(num);
        }

        // Handle numbers up to 999,999 (thousands)
        const thousands = Math.floor(num / 1000);
        const remainder = num % 1000;
        let words = convertHundred(thousands) + ' thousand';

        if (remainder) {
            // Use 'and' if remainder is less than 100 for a more natural reading
            words += remainder < 100 ? ' and ' : ' ';
            words += convertHundred(remainder);
        }

        return words;
    };

    // Convert the input to string
    const stringValue = value.toString();
    let result;

    // Check if it's a simple number (or decimal)
    if (/^\d+(\.\d+)?$/.test(stringValue)) {
        // For whole numbers, convert to words if required
        if (convertToWords && !stringValue.includes('.')) {
            result = convertNumberToWords(parseInt(stringValue, 10));
        } else {
            // Format with commas if not converting to words
            if (stringValue.includes(',')) {
                result = stringValue; // Already formatted
            } else {
                const parts = stringValue.split('.');
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                result = parts.join('.');
            }
        }
    } else {
        // For text containing numbers: find sequences of 4+ digits and process them
        result = stringValue.replace(/\b(\d{4,})\b/g, match => {
            // Skip if already formatted with commas
            if (match.includes(',')) return match;

            if (convertToWords) {
                return convertNumberToWords(parseInt(match, 10));
            } else {
                return match.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        });
    }

    // If converting to words, perform the extra modifications:
    if (convertToWords) {
        // 1. Add "..." after each occurrence of the word "found" (ignoring case)
        result = result.replace(/\bfound\b/gi, match => match + " ...");

        // 2. Randomly insert "uh" or "um" before indefinite articles "a" or "an" (ignoring case)
        result = result.replace(/\b(a|an)\b/gi, match => {
            const filler = Math.random() < 0.5 ? "uh" : "um";
            return filler + " " + match;
        });

        // 3. Append ". ." after each comma
        result = result.replace(/,/g, ',. .');
    }

    return result;
};

export { formatDateTime, isImageURL, generateDarkColor, capitalizeFirstLetter, enhanceTextForTTS };